export default __webpack_public_path__ + "static/media/mycloudwallet-signup.b4707b52.png";